export function mod(n: number, m: number) {
    return (n % m + m) % m;
}



// WEBPACK FOOTER //
// ./src/client/components/utils.ts